import React, { useState } from 'react'
import { SearchOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal } from "antd";
import backButton from '../../assets/images/back_button_arrow.svg';
import demandIcon from '../../assets/images/icons/demand_icon.svg';
const { Option } = Select;

function resetFormView() { };
const CreateAdvertiser = ({ handlePageViewChange }) => {

    const onChange = (value) => {
        console.log(`selected ${value}`);
    };
    const onSearch = (value) => {
        console.log('search:', value);
    };

    const [searchValue, setSearchValue] = useState('');
    const [filterApply, setFilterApply] = useState({
        publisher: [],
    });

    const options = [
        { value: 'jack1', label: 'Jack 1' },
        { value: 'lucy1', label: 'Lucy 1' },
        { value: 'lucy8', label: 'Lucy 8' },
        { value: 'tom8', label: 'Tom 8' },
        { value: 'jack9', label: 'Jack 9' },
        { value: 'lucy9', label: 'Lucy 9' },
        { value: 'tom9', label: 'Tom 9' },
    ];


    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={demandIcon} alt="USP" /> Advertiser
                            </Link>
                        </li>
                        <li className="primary">Create Advertiser</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}
                        />
                        <h1 className="heading">
                            Create Advertiser
                        </h1>
                    </div>
                </div>
                <div className='container_box--content pt_20'>
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Basic Info</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Name * </label>
                                                <Input className='form_control basic' placeholder='Advertiser Name' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Email * </label>
                                                <Input className='form_control basic' placeholder='Email ID' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Status * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Password</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container mb-0">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Password* </label>
                                                <Input type='password' className='form_control basic' placeholder='Create Password' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Confirm Password * </label>
                                                <Input type='password' className='form_control basic' placeholder='Confirm Password' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content"> back </button>
                        <button className="w_120_d2 btn btn_primary w_fit_content">Create</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateAdvertiser
